export default __webpack_public_path__ + "static/media/ic_gallery.2ccee804.svg";